import Head from 'next/head';
import React from 'react';

const Header: React.FC = (): JSX.Element => {
  return (
    <Head>
      <title>Contact Us - Zola</title>
      <link rel="canonical" href="https://www.zola.com/contact-us" />
      <meta
        name="description"
        content="Contact us for help with your Wedding Website, Registry, or with general support questions. Reach us 7 days a week, 10am–6pm EST at support@zola.com"
      />
      <meta
        property="og:description"
        content="Contact us for help with your Wedding Website, Registry, or with general support questions. Reach us 7 days a week, 10am–6pm EST at support@zola.com"
      />
      <meta property="og:title" content="Contact Us - Zola" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="zola.com" />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
    </Head>
  );
};

export default Header;
